// extracted by css-extract-rspack-plugin
export default {"button":"button-XHhKaF"};